function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.688 0c.022 0 .04.01.062.013.028-.003.055-.013.083-.013C13.477 0 14 .523 14 1.167v10.5c0 .498-.317.943-.794 1.109l-3.511 1.17a1.23 1.23 0 01-.362.054 1.167 1.167 0 01-1.166-1.167v-.583h-1.75c-.965 0-1.75-.785-1.75-1.75V8.167a.583.583 0 111.166 0V10.5c0 .321.262.583.584.583h1.75v-8.75c0-.498.317-.943.794-1.109l.173-.057H6.417a.584.584 0 00-.584.583V3.5a.582.582 0 11-1.166 0V1.75c0-.965.785-1.75 1.75-1.75h6.27zM3.14 2.96c.218.091.36.304.36.54v1.75h2.333a.584.584 0 110 1.167H3.5v1.75a.585.585 0 01-.996.412L.171 6.246a.583.583 0 010-.825l2.333-2.333a.584.584 0 01.636-.127z",
  fill: "#747474",
  fillRule: "evenodd"
});

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default SvgLogout;